import React, { useContext, useState, useEffect , useRef } from 'react';
import { Paper, Box, Grid, Avatar, Chip, Switch, FormControlLabel, Typography, InputAdornment, CircularProgress, MenuItem, TextField, IconButton, Pagination , Checkbox } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from "moment";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import MyTable from '../../components/Schedule/MyTable';
import SearchIcon from "@mui/icons-material/Search";
import ChecklistCard from './ChecklistCard';
import EmptyState from '../../components/Error/EmptyState';
import './checklist.css'
import AuthContext from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { varFormatTime } from '../../utils/helperFunctions';
import { useReactToPrint } from "react-to-print";

const Checklist = () => {
  const [loading, setLoading] = useState(false);
  const { permission, user } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [searchResult, setSearchResult] = useState('');
  const [duration, setDuration] = useState('');
  const [checklistType, setChecklistType] = useState('');
  const [viewType, setViewType] = useState("list");
  const [allChecklist, setAllChecklist] = useState(null)
  const [checklistDetails, setChecklistDetails] = useState([])
  const [title, setTitle] = useState("")
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [noData, setNoData] = useState(false);
  const [isFirstTime, setIsFirsttime] = useState(true);
	const printRef = useRef();
	const printRef2 = useRef();

	const itemsPerPage = 10;
	const [checklistAllData , setChecklistAllData]  = useState([]);

	const handlePrint = useReactToPrint({
		content: () => printRef.current,
		onBeforeGetContent: () =>
		new Promise((resolve) => {
			document.fonts.ready.then(() => resolve());
		}),
	});

	const handlePrint2 = useReactToPrint({
		content: () => printRef2.current,
		onBeforeGetContent: () =>
		new Promise((resolve) => {
			document.fonts.ready.then(() => resolve());
		}),
	});
	
	let printFunction = () => {
		handlePrint()
	}

	const handleChecklistData = async (id) => {
		if (!id) return;
		setLoading(true);

		try {
			await Promise.all([
				getChecklistData(id),
				getChecklistDetails(id),
			]);

			setTimeout(()=>{
				printFunction()
				setLoading(false)
			} , 2000)
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

  const columns = [
    {
      field: 'title', headerName: 'Title', flex: 1, minWidth: 220, valueGetter: (params) => params.row.title
    },
    {
      field: 'location', headerName: 'Parent Location', flex: 1, minWidth: 200, valueGetter: (params) => params.row.location.location_description,
    },
    {
      field: 'status', headerName: 'Status', flex: 1, minWidth: 130,
      renderCell: (params) => {
        return (
          params?.row?.status == 'active' ?
            <Chip style={{ width: '100px' }}
              color={'DarkGreen'}
              label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)} />
            :
            <Chip
              sx={{
                backgroundColor: '#EDE1E1',
                color: '#000000',
                cursor: 'pointer',
                width: '100px'
              }}
              label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)}
            />
        );
      }
    },
    {
      field: 'duration', headerName: 'Duration', flex: 1, minWidth: 200,
      renderCell: (params) => {
        return (
          <>
            {params.row.duration &&
              <Chip style={{ width: "65%" }}
                sx={{
                  borderColor: '#2B3F6C',
                  backgroundColor: '#F5F5F5',
                  color: '#2B3F6C',
                }}
                variant="outlined"
                label={params.row.duration.charAt(0).toUpperCase() + params.row.duration.slice(1)} />
            }        </>)
      }
    },
    {
      field: 'created', headerName: 'Created by', flex: 1, minWidth: 220, valueGetter: (params) => params.row.employee_full_name
    },
    {
      field: 'assigned', headerName: 'Assigned to', flex: 1, minWidth: 180, valueGetter: (params) => params.row.checklist_assign?.employee_full_name ? params.row.checklist_assign?.employee_full_name : params.row.checklist_assign?.position_name
    },
    {
      field: 'created_on', headerName: 'Created on', flex: 1, minWidth: 200, valueGetter: (params) => { return varFormatTime(params.row.created_at, user?.Time_Format) }
    },
		{
			field: 'action', headerName: 'Actions', flex: 1, minWidth: 480,
			renderCell: (params) => {
				return (
					<Box sx={{ display: 'flex', gap: 1 }}>

						{/* Edit Chip */}
						{(permission?.includes("Checklist_Auth")) &&
							<div>
								{(permission && permission.includes('Emp_Auth')) || params?.row?.created_by == user?.Emp_Code ?
									<Link to={`/firehouse/edit-checklist/${params?.row?.id}`}>
										<Chip
											variant="outlined"
											sx={{
												backgroundColor: '#EAECF0',
												color: '#2B3F6C',
												border: '1px solid #2B3F6C',
												cursor: 'pointer'
											}}
											avatar={<Avatar src="/images/edit.png" style={{ width: 20, height: 20, padding: 2 }} />}
											label={'Edit'}
										/>
									</Link>
									:
									<Chip
											variant="outlined"
											sx={{
												backgroundColor: '#EAECF0',
												color: '#2B3F6C',
												border: '1px solid #2B3F6C',
											}}
											avatar={<Avatar src="/images/edit.png" style={{ width: 20, height: 20, padding: 2 }} />}
											label={'Edit'}
											disabled={true}
										/>
								}
							</div>
						}

						{/* Checklists */}
						<Chip
							variant="outlined"
							sx={{
								backgroundColor: '#EAECF0',
								color: '#2B3F6C',
								border: '1px solid #2B3F6C',
								cursor: 'pointer'
							}}
							avatar={<Avatar src="/images/eye.png" style={{ width: 28, height: 24, padding: 2 }} />}
							label={'Checklists'}
							onClick={() => {
								setShowModal(true)
								setTitle(params.row?.title)
								getChecklistDetails(params?.row?.id)
							}}
						/>

						{/* Schedule Chip */}
						<Link to={`/firehouse/checklist-schedule/${params?.row?.id}`}>
							<Chip
								variant="outlined"
								sx={{
									backgroundColor: '#BF1D2D',
									color: '#FFFFFF', // Dark Blue text
									border: '1px solid #BF1D2D',
									cursor: 'pointer'
								}}
								avatar={<Avatar src="/images/eye1.png" style={{ width: 28, height: 24, padding: 2 }} />}
								label={'Schedule'}
							/>
						</Link>

						{(permission?.includes("Checklist_Auth")) &&
							<div>
									{params?.row?.created_by == user?.Emp_Code ?
										<Chip
											variant="outlined"
											sx={{
												backgroundColor: '#EAECF0',
												color: '#BF1D2D',
												border: '1px solid #BF1D2D',
												cursor: 'pointer'
											}}
											onClick= {()=>deleteChecklist(params?.row?.id)}
											avatar={<Avatar src="/images/delete-red.png" style={{ width: 21, height: 22, padding: 4 }} />}
											label={'Delete'}
										/>
									:
										<Chip
											variant="outlined"
											sx={{
												backgroundColor: '#EAECF0',
												color: '#BF1D2D',
												border: '1px solid #BF1D2D',
											}}
											avatar={<Avatar src="/images/delete-red.png" style={{ width: 21, height: 22, padding: 4 }} />}
											label={'Delete'}
											disabled={true}
										/>
									}
							</div>
						}

						{/* Print */}
						<Chip
							variant="outlined"
							sx={{
								backgroundColor: '#EAECF0',
								color: '#BF1D2D',
								border: '1px solid #BF1D2D',
								cursor: 'pointer',
								padding:'6px 8px'
							}}
							icon={<img src="/images/print.svg" alt="print" style={{ width: 16, height: 16 }} />}
							label={'Print'}
							onClick={() => {
								handleChecklistData(params?.row?.id)
							}}
							disabled={(permission && permission.includes('Emp_Auth') || params?.row?.created_by == user?.Emp_Code) ? false : true}
						/>
					</Box>
				);
			},
		},
		{
			field: 'updateStatus', headerName: 'Status', flex: 1, minWidth: 80,
			renderCell: (params) => {
				return (

					<div>
						<Switch
							checked={params.row.status == 'active'}
							onChange={
								(permission?.includes("Checklist_Auth"))
									? () => updateChecklistStatus(params.row.id, params.row.status)
									: undefined
							}
							color="primary"
						/>
					</div>
				)
			}
		}
	]

	const getChecklist = (loader = true) => {
		const body = {
			'limit': itemsPerPage,
			'page': currentPage,
			'search': searchResult,
			'duration': duration == 'all' ? '' : duration,
			'assigned': checklistType
		}

		if (loader) {
			setLoading(true)
		}
		ApiService.post('/checklist', body)
			.then(({ data }) => {
				if (data?.data?.length == 0 && searchResult == '' && checklistType == '' && duration == '') {
					setNoData(true)
				} else {
					setNoData(false)
				}
				setAllChecklist(data?.data);
				setTotalPages(Math.ceil(data?.total / data?.per_page));
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const handlePageChange = (_, value) => {
		setCurrentPage(value);
	};

	const getChecklistDetails = (id) => {
		const body = {
			"checklist_id": id
		}
		ApiService.post('/checklist/details', body)
			.then(({ data }) => {
				setChecklistDetails(data)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const updateChecklistStatus = (id, currStatus) => {
		var newStatus = 'active'
		if (currStatus == 'active') {
			newStatus = 'inactive'
		}
		const body = {
			"id": id,
			"status": newStatus
		}
		ApiService.post('/checklist/update-status', body)
			.then((data) => {
				getChecklist(false)
				toast.success(data?.message)
			})
			.catch((e) => {
				setLoading(false);
			})
	}

		const deleteChecklist = (id) => {
		const body = {
			'id': id,
		}
		ApiService.post('/checklist/delete', body)
			.then(( data ) => {
				toast.success(data?.message)
				getChecklist()
				setLoading(false);
			})
			.catch(( error ) => {
				toast.error(error?.data?.message)
				setLoading(false);
			})
	}

	useEffect(() => {
		getChecklist()
		setIsFirsttime(false)
	}, [])

	useEffect(() => {
		if (!isFirstTime) {
			getChecklist(false)
		}
	}, [currentPage, searchResult, duration, checklistType])

	const getChecklistData = (id) => {
		if (id) {
			ApiService.get('/checklist/edit_details/' + id)
				.then(async ({ data }) => {
					setChecklistAllData(data?.data || [])
				})
				.catch((e) => {
					console.error(e || 'error')
				})
		}
	}


	return (
		<>
			{loading ? (
				<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
					<CircularProgress />
				</Paper>
			)
				:
				(
					<>
						<Paper className="p-4 font-fam" style={{ marginTop: "1rem", minHeight: '98%' }}>
							<Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px" }} >
								<Grid item xs={10} md={2.5}>
									<Typography variant="h5">Checklist Definition</Typography>
								</Grid>

								{!noData &&
									<>
										{(permission.includes("Checklist_Auth")) &&
											<Grid item xs={10} md={"auto"}>
												<div>
													<Link to="/firehouse/checklist-add">
														<ButtonTheme type='submit' variant="filled" color='primary'>
															Add New
														</ButtonTheme>
													</Link>
												</div>
											</Grid>
										}

										{/* DropDown Menu Duration */}
										<Grid items xs={12} sm={12} md={2} className='font-fam'>
											<TextField
												select size='small'
												placeholder='Duration'
												className='mt-0 w-100' color='secondary' variant="outlined"
												label='Duration'
												value={duration}
												onChange={(e) => setDuration(e.target.value)}
												InputProps={{
													sx: {
														height: '48px',
														fontSize: '14px'
													}
												}}
												InputLabelProps={{
													sx: {
														marginTop: '4px',
														fontSize: '14px'
													},
												}}
											>
												<MenuItem value={"all"} key={""} className='font-fam'>{"All"} </MenuItem>
												<MenuItem value={"daily"} key={"daily"} className='font-fam'>{"Daily"} </MenuItem>
												<MenuItem value={"everyotherday"} key={"everyotherday"} className='font-fam'>{"Every Other Day"} </MenuItem>
												<MenuItem value={"weekly"} key={"weekly"} className='font-fam'>{"Weekly"} </MenuItem>
												<MenuItem value={"biweekly"} key={"biweekly"} className='font-fam'>{"Bi-weekly"} </MenuItem>
												<MenuItem value={"monthly"} key={"monthly"} className='font-fam'>{"Monthly"} </MenuItem>
											</TextField>
										</Grid>

										{/* DropDown Menu All */}
										<Grid items xs={12} sm={12} md={2} className='font-fam'>
											<TextField
												select size='small'
												placeholder='Type'
												className='mt-0 w-100' color='secondary' variant="outlined"
												label='Type'
												value={checklistType}
												onChange={(e) => setChecklistType(e.target.value)}
												InputProps={{
													sx: {
														height: '48px',
														fontSize: '14px'
													}
												}}
												InputLabelProps={{
													sx: {
														marginTop: '4px',
														fontSize: '14px'
													},
												}}
											>
												<MenuItem value={"all"} key={"all"} className='font-fam'>{"All"} </MenuItem>
												<MenuItem value={"myChecklist"} key={"myChecklist"} className='font-fam'>{"My checklist"} </MenuItem>
												<MenuItem value={"otherChecklist"} key={"otherChecklist"} className='font-fam'>{"Other checklist"} </MenuItem>
											</TextField>
										</Grid>

										{/* List & Grid Icon */}
										<Grid item xs={6} sm={6} md={'auto'}>
											<div
												style={{
													height: "48px",
													border: "1px solid #EAECF0",
													borderRadius: "8px",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}
											>
												<div
													style={{
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														width: "48px",
														height: "48px",
														borderRight: "1px solid #EAECF0",
														cursor: "pointer",
													}}
													onClick={() => setViewType("list")}
												>
													<img
														src={viewType === "list" ? "/images/listview.svg" : "/images/list-empty.svg"}
														height="20px"
														width="20px"
													/>
												</div>

												<div
													style={{
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														width: "48px",
														height: "48px",
														cursor: "pointer",
													}}
													onClick={() => setViewType("card")}
												>
													<img
														src={viewType === "list" ? "/images/card-empty.svg" : "/images/card.svg"}
														height="22px"
														width="22px"
													/>
												</div>
											</div>
										</Grid>

										{/* Search field */}
										<Grid item xs={12} sm={12} md={2}>
											<TextField
												variant="outlined"
												placeholder="Search from title"
												onChange={(e) => setSearchResult(e.target.value)}
												className="w-100"
												value={searchResult}
												InputProps={{
													endAdornment: (
														<InputAdornment position="end">
															<IconButton>
																<SearchIcon />
															</IconButton>
														</InputAdornment>
													),
													sx: {
														height: '48px',
														fontSize: '14px',
														marginRight: '10px',
													},
												}}
											/>
										</Grid>
									</>
								}
							</Grid>

							{(allChecklist && allChecklist.length == 0) && (checklistType != '' || searchResult.length > 0 || duration != '') ?
								<div className='d-flex align-items-center' style={{ height: 550 }}>
									<EmptyState />
								</div>

								:
								!allChecklist || allChecklist.length == 0 ?
									<Box>
										<div className='mt-4' style={{ color: '#555555' }}>
											No Checklist Definition available right now.
										</div>

										<div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
											<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
											<span className='mt-4' style={{ color: '#555555' }}>
												<Link to="/firehouse/checklist-add">
													{(permission.includes("Checklist_Auth")) &&
														<ButtonTheme type='submit' variant="filled" color='primary'>
															Add Checklist Definition
														</ButtonTheme>
													}
												</Link>
											</span>
										</div>
									</Box>
									:
									<>
										{viewType == "list" ?
											<div className='mt-4'>
												<MyTable
													rows={allChecklist}
													columns={columns}
													perPage={10}
													rowCount={allChecklist.length}
													checkboxSelection={false}
													hideFooter={true}
												/>
											</div>
											:
											<>
												{allChecklist.map((item) => (
													<ChecklistCard data={item} setShowModal={setShowModal} getChecklistDetails={getChecklistDetails} setTitle={setTitle} getChecklist={getChecklist} />
												))}
											</>
										}
										<Pagination
											count={totalPages}
											page={currentPage}
											onChange={handlePageChange}
											color="primary"
											className="mt-4 d-flex"
											style={{ justifyContent: 'end' }}
										/>
									</>
							}
						</Paper >
					</>
				)}

			{/* Checklist Pop-Up View */}
			<div className='font-fam' ref={printRef2}>
				<Modal show={showModal} size="lg"
					onHide={() => {
						setShowModal(false)
						setChecklistDetails([])
					}}>

					<Modal.Header closeButton>
						<Modal.Title>Checklist Details - {title}</Modal.Title>
						<ButtonTheme color='primary' style={{marginLeft:'30%'}} onClick={handlePrint2}>
							Print
						</ButtonTheme>
					</Modal.Header>

					<Modal.Body style={{ padding: 22 }}>
						<Grid item xs={12} sm={6} md={6} ref={printRef2}>
							<h4 style={{marginBottom:'15px' , fontWeight:'550'}} className="print-header">
								Checklist Details - {title}
							</h4>
							<div className='font-fam model-bg mt-2'>
								{checklistDetails && checklistDetails.map((item) => (
									// <div className='row' style={{ marginTop: '6px', marginBottom: '6px' , paddingLeft:'10px' }}>
									// 	<div className='col-md-1'>
									// 		<Checkbox sx={{marginTop:'-7px'}}/>
									// 	</div>
									// 	<div className='col-md-1' style={{marginLeft:'-16px'}}>
									// 		{item?.location?.type == 'location' ?
									// 				<img src='/images/Building.png' style={{ width: 30, height: 30 }} />
									// 				: item?.location?.type	 == 'location_item' ?
									// 				<img src="/images/location-item.svg" style={{ width: 23, height: 23 }} />
									// 				:
									// 				<img src="/images/location-blue.svg" style={{ width: 25, height: 25 , marginTop:'5px' }} />
									// 		}
									// 	</div>


									// 	<div className="col-md-5">
									// 		<span style={{ color: !item.description ? '#cccccc' : 'inherit', pointerEvents: !item.description ? 'none' : 'auto', marginLeft:'-24px'}}>
									// 			{item.description || "--"}
									// 		</span>
									// 	</div>

									// 	<div className='font-fam col-md-5'>
									// 		<span style={{ color: '#6E7C87' }}>{item?.location?.type == 'location' ? 'Location' : item?.location?.type	 == 'location_item' ? 'Location & Item' : "Item"}</span> : {(() => {
									// 			const desc = item?.item_location?.item?.item_description || item?.location?.location_description;
									// 			return desc ? desc.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1)) : '';
									// 		})()}
									// 	</div>
									// </div>

									<div style={{display:'flex'}}>
										<div style={{display:'flex' , gap:'6px' , width:'400px'}}>
											<div className='font-fam' style={{marginTop:'-7px'}}>
												<Checkbox />
											</div>
											<div>
												{item?.location?.type == 'location' ?
													<img src='/images/Building.png' style={{ width: 25, height: 25 }} />
													: item?.location?.type	 == 'location_item' ?
													<img src="/images/location-item.svg" style={{ width: 23, height: 23 }} />
													:
													<img src="/images/location-blue.svg" style={{ width: 25, height: 25 }} />
											}
											</div>
											<div className='font-fam'>
												{(() => {
													const desc = item?.item_location?.item?.item_description || item?.location?.location_description;
													return desc ? desc.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1)) : '';
												})()}
											</div>
										</div>
										<div>
											{item.description ? 
												<p>Description : <span> {item.description}</span></p> : 
												<p>Description : <span style={{color:'#cccccc'}}>--</span>
											</p>
											}
										</div>
									</div>
								))}
							</div>

						</Grid>
					</Modal.Body>
				</Modal>
			</div>

			<div ref={printRef} className='print-header'>
				<div className='d-flex align-items-center justify-content-between'>
					Firehouse247
					<div className='text-center'>
						<h4>Checklist Data Report</h4>
					</div>
					<img src='/images/black-logo.png' style={{ width: 60, height: 60 }} />
				</div>

				<div className='mt-2'>
					<h5>Checklist Definition</h5>
					<div className='font-fam p-3 mt-2' 
					style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
						<div>
							<p style={{marginBottom:'0px'}}>Title : <strong>{checklistAllData?.title}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Status : <strong>{checklistAllData?.status}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px', paddingTop:'6px'}}>Duration : <strong>{checklistAllData?.duration}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Day : <strong>{checklistAllData?.day}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Time : <strong>{checklistAllData?.time}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Assigned by : <strong>{checklistAllData?.employee_full_name}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Assigned to : <strong>{checklistAllData?.checklist_assign?.employee_full_name}</strong></p>
						</div>
						<div>
							<p style={{ marginBottom: "0px" , paddingTop:'6px'}}>
								Notify to :
								<strong>
									{checklistAllData?.notify
										?.map(
											(name) =>
												` ${name.notify_employee_first_name} ${name.notify_employee_last_name}`
										)
										.join(", ")}
								</strong>
							</p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Notify Checklist Update to : <strong>{checklistAllData?.notify_checklist_update_to_name}</strong></p>
						</div>
					</div>
				</div>

				{checklistAllData?.description &&
					<div className='mt-4'>
						<h5>Checklist Description</h5>
						<div className='font-fam p-3 mt-2' style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
							{checklistAllData?.description}
						</div>
					</div>
				}

				<div className='mt-4'>
					<h5>Checklist</h5>
					<div className='font-fam p-3 mt-2' style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
						{checklistDetails && checklistDetails.map((item) => (
							<div style={{display:'flex'}}>
								<div style={{display:'flex' , gap:'6px' , width:'280px'}}>
									<div className='font-fam' style={{marginTop:'-7px'}}>
										<Checkbox />
									</div>
									<div>
										{item?.location?.type == 'location' ?
											<img src='/images/Building.png' style={{ width: 25, height: 25 }} />
											: item?.location?.type	 == 'location_item' ?
											<img src="/images/location-item.svg" style={{ width: 23, height: 23 }} />
											:
											<img src="/images/location-blue.svg" style={{ width: 25, height: 25 }} />
									}
									</div>
									<div className='font-fam'>
										{(() => {
											const desc = item?.item_location?.item?.item_description || item?.location?.location_description;
											return desc ? desc.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1)) : '';
										})()}
									</div>
								</div>
								<div>
									{item.description ? 
										<p>Description : <span> {item.description}</span></p> : 
										<p>Description : <span style={{color:'#cccccc'}}>No description</span>
									</p>
									}
								</div>
							</div>
						))}
					</div>
				</div>

			</div>
		</>
	)
}
export default Checklist
